addScripts = () => {
  //   console.log('addScripts()');

  loadJS('/static/jquery-3.5.1.min.js');
  loadJS('/static/slick-1.8.1.min.js');

  waitForJQuery(loadCarousel);

  // setTimeout(addGoogleAnalytics, 1000);
  setTimeout(addHubspot, 1250);
  setTimeout(addIntercom, 1500);
};

var waitForJQuery = function (callback) {
  if (typeof jQuery != 'undefined') {
    callback();
  } else {
    setTimeout(function () {
      waitForJQuery(callback);
    }, 300);
  }
};

function loadJS(url) {
  var tag = document.createElement('script');
  tag.src = url;
  tag.async = false;
  document.body.appendChild(tag);
}

function loadCarousel() {
  var carousel = $('.customer-carousel');

  if (typeof carousel.slick !== 'function') {
    setTimeout(function () {
      loadCarousel();
    }, 300);
    return;
  }

  carousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 5,
    prevArrow:
      "<img alt='arrow left' class='slick-prev' src='/img/arrow_left.svg'>",
    nextArrow:
      "<img alt='arrow right' class='slick-next' src='/img/arrow_right.svg'>",

    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  carousel.show();
}

function addGoogleAnalytics() {
  if (
    typeof disableGoogleAnalytics !== 'undefined' &&
    disableGoogleAnalytics === true
  ) {
    console.log('Disabling Google Analytics');
    return;
  }
  //   console.log('addGoogleAnalytics()');
  var s = document.createElement('script');
  s.id = 'hs-script-loader';
  s.type = 'text/javascript';
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=UA-113284052-1';
  var a = document.getElementsByTagName('script')[0];
  a.parentNode.insertBefore(s, a);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'UA-113284052-1');
  gtag('config', 'G-K719L37X7P');
}

function addHubspot() {
  if (typeof disableHubspot !== 'undefined' && disableHubspot === true) {
    console.log('Disabling Hubspot');
    return;
  }
  //   console.log('addHubspot()');
  var s = document.createElement('script');
  s.id = 'hs-script-loader';
  s.type = 'text/javascript';
  s.async = true;
  s.src = 'https://js.hs-scripts.com/4689761.js';
  var a = document.getElementsByTagName('script')[0];
  a.parentNode.insertBefore(s, a);
}

function addIntercom() {
  if (typeof disableIntercom !== 'undefined' && disableIntercom === true) {
    console.log('Disabling Intercom');
    return;
  }
  //   console.log('addIntercom()');
  var user_email = localStorage.getItem('ObkioUserEmail');
  var user_hash = localStorage.getItem('ObkioIntercomHash');
  // Patch: The item name initially had a grammatical error
  if (!user_hash) {
    user_hash = localStorage.getItem('ObioIntercomHash');
  }
  if (user_email && user_hash) {
    window.intercomSettings = {
      app_id: 'clbytz3j',
      email: user_email,
      user_hash: user_hash,
    };
  } else {
    window.intercomSettings = {
      app_id: 'clbytz3j',
    };
  }

  var w = window;
  var ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/clbytz3j';
      var x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }

    if (document.readyState === 'complete') {
      l();
    }
  }
}
